import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { ContractComponent } from './contract/contract.component';
import { ProductsComponent } from './products/products.component';
import { ProjectsComponent } from './projects/projects.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { BillingReportsComponent } from './billing-reports/billing-reports.component';
import { ContractSprintComponent } from './contract-sprint/contract-sprint.component';
import { ProductSprintComponent } from './product-sprint/product-sprint.component';
import { ProjectSprintComponent } from './project-sprint/project-sprint.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { ModelComponent } from './model/model.component';
import { BundleSprintComponent } from './bundle-sprint/bundle-sprint.component';

const routes: Routes = [
  {
    path:'',
    children:[
      {
        path:'list' ,component:ListComponent
      },
      {
        path:'add' ,component:AddComponent
      },
      {
        path:'model' ,component:ModelComponent
      },
      {
        path:'model/edit/:id' ,component:ModelComponent
      },
      {
        path:'edit/:id' ,component:AddComponent
      },
      {
        path:'view/:id' ,component:ViewComponent
      },
      {
        path:'contracts' ,component:ContractComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['Managment','Engineering','Sales','admin'] } 
          
      },
      {
        path:'products' ,component:ProductsComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['Managment','Engineering','admin'] } 
      },
      {
        path:'projects' ,component:ProjectsComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'billing-reports' ,component:BillingReportsComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'contract-sprint' ,component:ContractSprintComponent,
          // canActivate: [PermissionGuard],
          // data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'product-sprint' ,component:ProductSprintComponent,
          // canActivate: [PermissionGuard],
          // data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'project-sprint' ,component:ProjectSprintComponent,
          // canActivate: [PermissionGuard],
          // data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'bundle-sprint' ,component:BundleSprintComponent,
          // canActivate: [PermissionGuard],
          // data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
      {
        path:'new-projects' ,component:NewProjectComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['Managment','Engineering','Training Moderator','Teacher','admin'] } 
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobsRoutingModule { }
